import { createSignal } from "solid-js"
import { useApi, isOk } from "../api";
import { useToast } from "../components/MessageBox";
import Text from "../components/Text";
import { firstError } from "../api/envelope";
import { useTranslation } from "../hooks/useTranslation";


export function TranslateLog() {

    const toast = useToast();
    const [log, setLog] = createSignal<string>("");
    const api = useApi();
    const { t } = useTranslation();

    async function translate() {
        const original = log();
        setLog(t("TRANSLATE_LOG_IN_PROGRESS"));
        const res = await api.jarDownload.translateLog({ log: original });

        if (isOk(res.data)) {
            const translated = res.data.value.translatedLog ?? "";
            setLog(translated);
            document.querySelector("textarea")!.value = translated;
            toast?.info(t("TRANSLATE_LOG_DONE"));
        } else {
            setLog(original);
            toast?.error(firstError(res.data) ?? t("TRANSLATE_LOG_FAILED"));
        }
    }

    return (
        <div class="dashboard-page">
            <h1><Text val="TRANSLATE_LOG" /></h1>
            <button onClick={translate}><Text val="TRANSLATE" /></button>
            <textarea
                onKeyDown={(e) => setLog(e.currentTarget.value)}
                onPaste={(e) => setLog(e.currentTarget.value)}
                onInput={(e) => setLog(e.currentTarget.value)}
                rows="20"
                style={{ width: "100%", "min-height": "400px" }}>
                {log()}
            </textarea>
        </div>
    );
}
